module.exports = __webpack_public_path__ + "img/stars-3--alt.13e7ee4.svg";